import LoaderAnimation from '../ui/LoaderAnimation';

export default function DialogLoader({ note }: { note?: string }) {
  return (
    <div className="text-text-light-high text-center w-full flex flex-col gap-4 items-center">
      <LoaderAnimation />
      <h5 className="font-bold">Just a moment</h5>
      {note && <p>{note}</p>}
    </div>
  );
}
